import { BASEURL } from '../../../Constants';
import { normalizeMaxRedials } from './constants';
import { notifyCreditsChanged } from '../../../services/creditsApi';

const readApiResponse = async (response, fallbackMessage) => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data?.error || data?.success === 0 || data?.success === false) {
    throw new Error(
      data?.message
      || data?.error_message
      || (typeof data?.error === 'string' ? data.error : '')
      || fallbackMessage
    );
  }
  return data;
};

export const fetchScenarios = async (setVoicesData, setScenariosData) => {
  const token = sessionStorage.getItem('token');
  const res = await fetch(`${BASEURL}/pentests/vishing/voices_scenrios`, {
    method: 'GET',
    headers: { 
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}` 
    }
  });
  const data = await readApiResponse(res, 'Unable to load vishing scenarios and voices.');
  const voices   = data.info?.voices   || [];
  const scenarios = data.info?.scenarios || [];

  // only call the setters if they exist
  if (typeof setVoicesData === 'function')   setVoicesData(voices);
  if (typeof setScenariosData === 'function') setScenariosData(scenarios);

  // return both so callers can also grab them
  return { voices, scenarios };
};

export const fetchCallerNumbers = async () => {
  const token = sessionStorage.getItem('token');
  const res = await fetch(`${BASEURL}/pentests/vishing/numbers`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    }
  });
  const data = await res.json().catch(() => ({}));

  if (!res.ok || data?.error) {
    throw new Error(data?.message || 'Unable to load caller numbers.');
  }

  return Array.isArray(data?.numbers)
    ? data.numbers
    : Array.isArray(data?.info?.numbers)
      ? data.info.numbers
      : [];
};


export const saveCampaign = async (name, companyName, companyDetails, recordDisclosureEnabled, users, organizationId) => {
  const token = sessionStorage.getItem('token');
  const normalizedUsers = (users || []).map((user) => {
    const campaignUser = { ...user };
    delete campaignUser.caller_number_manually_changed;
    return {
      ...campaignUser,
      caller_number: campaignUser.caller_number || null,
      max_redials: normalizeMaxRedials(campaignUser.max_redials)
    };
  });
  const scope = { users: normalizedUsers, company: { name: companyName, details: companyDetails, record_disclosure: recordDisclosureEnabled } };
  const res = await fetch(`${BASEURL}/pentests/vishing`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ name, scope, pentest_type: 'Vishing', organizationId: organizationId })
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok || data?.error) {
    throw new Error(data?.message || 'Unable to create the vishing campaign.');
  }
  notifyCreditsChanged({ reason: 'pentest-created', pentestId: data.pentestId });
  return data.pentestId;
};

export const startCalls = async (id) => {
  const token = sessionStorage.getItem('token');
  const response = await fetch(`${BASEURL}/pentests/vishing/start?pentest_id=${id}`, {
    headers: { Authorization: `Bearer ${token}` }
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data?.error) {
    throw new Error(data?.message || 'Unable to start the vishing campaign.');
  }
  notifyCreditsChanged({ reason: 'pentest-started', pentestId: id });
};

export const generateCustomScenario = async (goal) => {
  const token = sessionStorage.getItem('token');
  const res = await fetch(`${BASEURL}/pentests/vishing/scenario/generate`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ goal })
  });
  const data = await readApiResponse(res, 'Unable to generate the custom scenario.');
  return data.scenario_information;
};

export const saveCustomScenario = async (scenarioData) => {
  const token = sessionStorage.getItem('token');
  const response = await fetch(`${BASEURL}/pentests/vishing/scenario`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(scenarioData)
  });
  return readApiResponse(response, 'Unable to save the custom scenario.');
};

export const updateCustomScenario = async (scenarioId, scenarioData) => {
  const token = sessionStorage.getItem('token');
  const response = await fetch(`${BASEURL}/pentests/vishing/scenario/${scenarioId}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(scenarioData)
  });
  const data = await readApiResponse(response, 'Unable to update the custom scenario.');
  return data.scenario;
};

export const deleteCustomScenario = async (scenarioId) => {
  const token = sessionStorage.getItem('token');
  const response = await fetch(`${BASEURL}/pentests/vishing/scenario/${scenarioId}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });
  return readApiResponse(response, 'Unable to delete the custom scenario.');
};
